import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { PAGE_CREATE_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const CREATE_PAGE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${PAGE_CREATE_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation createPage($input: CreatePageInput!) {
    createPage(input: $input) {
      page {
        ...PageCreateFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
